import { render, staticRenderFns } from "./icon-predictive.vue?vue&type=template&id=8d298c08&scoped=true&"
import script from "./icon-predictive.vue?vue&type=script&lang=js&"
export * from "./icon-predictive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d298c08",
  null
  
)

export default component.exports